import styles from '../ServiceUser/ServiceUser.module.css';
import '../../resources/css/admin_style.css';
import React, { useContext, useEffect, useState } from 'react';
import { IAM_SERVER_SERVICE_USER } from '../../utils/Config';
import axios from '../../utils/api/axios';
import { DialogEnum, showDialog } from '../../utils/dialog/Dialog';
import { TableContext } from '../../utils/contextapi/TableProvider';
import { useSelectedService } from '../../utils/contextapi/ServiceProvider';
import { useInnocodeLoadingOverlay } from '@intsoft/innocode-core';
import ServiceUserApprovalTable from './component/ServiceUserApprovalTable';
import dayjs from 'dayjs';

function ServiceUserApproval({ isMobile, setMovePage }) {
    const { show: showLoading, hide: hideLoading } = useInnocodeLoadingOverlay();
    const context = useContext(TableContext);
    const { selectedService } = useSelectedService();
    const [isMobileWindow, setIsMobileWindow] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [searchType, setSearchType] = useState('');
    const [cellData, setCellData] = useState([]);
    const [page, setPage] = useState(0);
    const listSize = 10;
    const [totalCount, setTotalCount] = useState(0);
    const [sortModel] = useState({
        field: 'createdDate',
        sort: 'desc',
    });

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (selectedService) {
            fetchData(page, listSize, searchType, searchValue);
        }
    }, [page, selectedService]);

    const fetchData = async (page = 0, size = listSize, searchType = '', searchValue = '') => {
        if (!selectedService) {
            setCellData([]);
            setTotalCount(0);
            return;
        }

        showLoading();
        try {
            const [start, end] = context.state.dateRange;
            const startDate = dayjs(start).startOf('day').valueOf();
            const endDate = dayjs(end).endOf('day').valueOf();

            const conditions = [
                { field: 'createdDate', operator: 'GREATER_THAN_OR_EQUAL', value: startDate },
                { field: 'createdDate', operator: 'LESS_THAN_OR_EQUAL', value: endDate },
                { field: 'serviceId', operator: 'EQUALS', value: selectedService.serviceId },
                { field: 'joinApproved', operator: 'EQUALS', value: 'false' },
            ];

            if (searchType.trim() && searchValue.trim()) {
                conditions.push({
                    field: searchType,
                    operator: 'LIKE',
                    value: searchValue,
                });
            }

            const params = {
                page,
                size,
                sortField: [sortModel.field],
                sortOrder: [sortModel.sort],
                operator: 'AND',
                conditions,
            };

            const res = await axios.post(`${IAM_SERVER_SERVICE_USER}/all-approval-pending`, params);
            const { data, recordsTotal } = res.data.data;
            setCellData(data || []);
            setTotalCount(recordsTotal || 0);
        } catch (error) {
            console.error(error);
            showDialog(DialogEnum.DEFAULT, '실패', '가입 승인 대기 목록 조회에 실패했습니다.');
        } finally {
            hideLoading();
        }
    };

    const handleSearch = (searchType, value) => {
        setSearchType(searchType);
        setSearchValue(value);
        setPage(0);
        fetchData(0, listSize, searchType, value);
    };

    const handleApprove = (serviceUserId) => {
        axios.post(`${IAM_SERVER_SERVICE_USER}/approve/${serviceUserId}`)
            .then(() => {
                showDialog(DialogEnum.SUCCESS, '승인 완료', '서비스 가입을 승인했습니다.');
                fetchData(page, listSize, searchType, searchValue);
            })
            .catch((error) => {
                console.error(error);
                showDialog(DialogEnum.DEFAULT, '실패', '서비스 가입 승인에 실패했습니다.');
            });
    };

    const handleReject = (serviceUserId) => {
        axios.post(`${IAM_SERVER_SERVICE_USER}/reject/${serviceUserId}`)
            .then(() => {
                showDialog(DialogEnum.SUCCESS, '거부 완료', '서비스 가입 요청을 거부했습니다.');
                fetchData(page, listSize, searchType, searchValue);
            })
            .catch((error) => {
                console.error(error);
                showDialog(DialogEnum.DEFAULT, '실패', '서비스 가입 거부에 실패했습니다.');
            });
    };

    const handleNextPage = () => {
        setPage((prevPage) => prevPage + 1);
    };

    const handlePrevPage = () => {
        setPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    return (
        <div className={styles.layoutWrapper}>
            <h3>서비스 가입 승인</h3>
            <div className={styles.pannelWrapper}>
                <div className={styles.permissionPanel}>
                    <ServiceUserApprovalTable
                        datas={cellData}
                        context={context}
                        onApprove={handleApprove}
                        onReject={handleReject}
                        onPrevPage={handlePrevPage}
                        onNextPage={handleNextPage}
                        disablePrev={page === 0}
                        disableNext={(page + 1) * listSize >= totalCount}
                        pageNumber={page}
                        totalCount={totalCount}
                        listSize={listSize}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        onSearch={handleSearch}
                        isMobileWindow={isMobileWindow}
                    />
                </div>
            </div>
        </div>
    );
}

export default ServiceUserApproval;
